import { z } from "zod";

// `POST /uploads` ships the photo as a multipart body part; the typed schema
// here documents headers/query (none required at MVP — auth + anonymous-session
// cookie handle ownership) so `@hono/zod-openapi` can register the route surface
// without claiming a body shape it doesn't validate inline.
export const UploadCreateRequest = z.object({});
export type UploadCreateRequest = z.infer<typeof UploadCreateRequest>;

export const UploadCreateResponse = z.object({
  jobId: z.guid(),
  projectId: z.guid(),
});
export type UploadCreateResponse = z.infer<typeof UploadCreateResponse>;
